/* G Decor Cart Drawer — intercept add-to-cart, render slide-out
   v2 — locale-aware cart routes + currency-aware money formatting
*/
(function(){
  // ---- locale-aware routes -------------------------------------------------
  // theme.routes.cart    = '/cart' on UK, '/en-us/cart' on US, etc.
  // theme.routes.cartAdd = '/cart/add.js' on UK, '/en-us/cart/add.js' on US
  var THEME_ROUTES   = (window.theme && window.theme.routes) || {};
  var CART_URL       = THEME_ROUTES.cart    || '/cart';
  var CART_JS_URL    = CART_URL + '.js';
  var CART_ADD_URL   = THEME_ROUTES.cartAdd || (CART_URL + '/add.js');
  var CART_CHANGE_URL= CART_URL + '/change.js';
  // Locale prefix derived from cart URL ('/en-us' or ''). Used to build any
  // other localized URLs (e.g. /collections/all in the empty-cart link).
  var LOCALE_PREFIX  = CART_URL.replace(/\/cart$/, '') || '';
  var COLLECTIONS_ALL_URL = LOCALE_PREFIX + '/collections/all';
  // Section Rendering API URL for the drawer itself. The two progress lines
  // (free delivery, Brass Range quantity ladder) can only be built in Liquid:
  // /cart.js does not tell us which collections a line item belongs to, so the
  // eligible-item count cannot be worked out client-side. After every cart
  // mutation we therefore re-render this section server-side and swap just the
  // [data-gd-cart-progress] block back in, which keeps both lines honest.
  var DRAWER_SECTION_URL = LOCALE_PREFIX + '/?section_id=gd-cart-drawer';

  // ---- money formatting using cart's currency -----------------------------
  // Falls back to GBP if cart currency unknown. Uses Intl.NumberFormat when
  // available so amounts render correctly per locale (£6.98 / $6.98 / 6,98 €).
  var CURRENCY_FALLBACK_SYMBOL = {
    GBP: '£', USD: '$', EUR: '€', AUD: 'A$', CAD: 'C$', AED: 'AED ', INR: '₹'
  };
  function fmtMoney(cents, currency){
    var amount = Number(cents) / 100;
    var code   = currency || 'GBP';
    if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency', currency: code,
          minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format(amount);
      } catch(_){}
    }
    var sym = CURRENCY_FALLBACK_SYMBOL[code] || (code + ' ');
    return sym + amount.toFixed(2);
  }

  // ---- drawer open / close -------------------------------------------------
  function openDrawer(){
    var d = document.getElementById('gd-cart-drawer');
    if(!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden','false');
    document.body.classList.add('gd-no-scroll');
  }
  function closeDrawer(){
    var d = document.getElementById('gd-cart-drawer');
    if(!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden','true');
    document.body.classList.remove('gd-no-scroll');
  }

  // ---- progress lines (server-rendered, so they can never go stale) --------
  function refreshProgress(){
    var d = document.getElementById('gd-cart-drawer');
    if(!d) return;
    var target = d.querySelector('[data-gd-cart-progress]');
    if(!target) return;
    fetch(DRAWER_SECTION_URL, {credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(html){
        if(!html) return;
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-gd-cart-progress]');
        if(fresh) target.innerHTML = fresh.innerHTML;
      })
      .catch(function(){ /* leave the last good render in place */ });
  }

  // ---- drawer rendering ----------------------------------------------------
  function renderDrawer(cart, justAdded){
    var d = document.getElementById('gd-cart-drawer');
    if(!d) return;
    var currency = (cart && cart.currency) || 'GBP';

    var statusEl = d.querySelector('[data-gd-cart-status]');
    if(statusEl){
      statusEl.innerHTML = justAdded
        ? '<svg viewBox="0 0 14 14" width="14" height="14" aria-hidden="true" style="vertical-align:-2px;margin-right:8px"><circle cx="7" cy="7" r="6" fill="none" stroke="#8B6F3F"/><path d="M4 7l2 2 4-4" fill="none" stroke="#8B6F3F" stroke-width="1.4"/></svg><strong>' + (justAdded.product_title || 'Item') + '</strong> added to your bag.'
        : 'Your bag';
    }
    var items = (cart && cart.items) || [];
    var html = items.length ? items.map(function(item){
      var variantLine = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="gd-cart-item__variant">' + item.variant_title + '</div>' : '';
      return '<li class="gd-cart-item"><a href="' + item.url + '" class="gd-cart-item__image"><img src="' + item.image + '" alt="' + (item.product_title || '').replace(/"/g,'&quot;') + '" loading="lazy"></a><div class="gd-cart-item__meta"><a href="' + item.url + '" class="gd-cart-item__name">' + item.product_title + '</a>' + variantLine + '<div class="gd-cart-item__row"><div class="gd-cart-item__qty"><button class="gd-cart-qty__btn" data-gd-cart-qty="-1" data-gd-line-key="' + item.key + '" aria-label="Decrease">−</button><span class="gd-cart-qty__val">' + item.quantity + '</span><button class="gd-cart-qty__btn" data-gd-cart-qty="1" data-gd-line-key="' + item.key + '" aria-label="Increase">+</button></div><div class="gd-cart-item__price">' + fmtMoney(item.line_price, currency) + '</div></div><button class="gd-cart-item__remove" data-gd-cart-remove="' + item.key + '">Remove</button></div></li>';
    }).join('') : '<li class="gd-cart-empty"><p>Your bag is empty.</p><a href="' + COLLECTIONS_ALL_URL + '" class="gd-btn gd-btn--ghost-dark" data-gd-cart-close>Discover the collection</a></li>';

    var itemsEl = d.querySelector('[data-gd-cart-items]');
    if(itemsEl) itemsEl.innerHTML = html;
    var subEl = d.querySelector('[data-gd-cart-subtotal]');
    if(subEl) subEl.textContent = fmtMoney(cart.total_price, currency);
    var countEl = d.querySelector('[data-gd-cart-count]');
    if(countEl) countEl.textContent = cart.item_count;
    document.querySelectorAll('.gd-cart-count').forEach(function(el){ el.textContent = cart.item_count; });
    // Every path into renderDrawer (add, quantity change, remove, open) ends
    // here, so this is the single place the progress lines need re-fetching.
    refreshProgress();
  }

  function fetchCart(){
    return fetch(CART_JS_URL, {credentials:'same-origin'}).then(function(r){ return r.json(); });
  }

  function showError(msg){
    var t = document.getElementById('gd-toast');
    if(!t){ t = document.createElement('div'); t.id='gd-toast'; t.className='gd-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._tm);
    t._tm = setTimeout(function(){ t.classList.remove('is-visible'); }, 3000);
  }

  // ---- intercept add-to-cart form submits ---------------------------------
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[type="submit"], button.product-form__submit, button.btn--add-to-cart');
    if(btn){ btn.classList.add('is-loading'); btn.disabled = true; }
    var fd = new FormData(form);
    fetch(CART_ADD_URL, { method:'POST', body:fd, headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, credentials:'same-origin' })
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, body:j}; }); })
      .then(function(res){
        if(!res.ok){ showError(res.body.description || 'Unable to add to bag.'); return; }
        return fetchCart().then(function(cart){ renderDrawer(cart, res.body); openDrawer(); });
      })
      .catch(function(err){ console.error('GD cart add error', err); showError('Network error — please try again.'); })
      .finally(function(){ if(btn){ btn.classList.remove('is-loading'); btn.disabled = false; } });
  }, true);

  // ---- drawer interactions -------------------------------------------------
  document.addEventListener('click', function(e){
    var open = e.target.closest('[data-gd-cart-open]');
    if(open){ e.preventDefault(); fetchCart().then(function(cart){ renderDrawer(cart, null); openDrawer(); }); return; }
    var close = e.target.closest('[data-gd-cart-close]');
    if(close){ e.preventDefault(); closeDrawer(); return; }
    var qty = e.target.closest('[data-gd-cart-qty]');
    if(qty){
      var key = qty.dataset.gdLineKey;
      var delta = parseInt(qty.dataset.gdCartQty, 10) || 0;
      var current = parseInt(qty.parentElement.querySelector('.gd-cart-qty__val').textContent, 10) || 0;
      var next = Math.max(0, current + delta);
      fetch(CART_CHANGE_URL, { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({id:key, quantity:next}) })
        .then(function(r){ return r.json(); })
        .then(function(cart){ renderDrawer(cart, null); });
      return;
    }
    var rem = e.target.closest('[data-gd-cart-remove]');
    if(rem){ e.preventDefault();
      fetch(CART_CHANGE_URL, { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({id: rem.dataset.gdCartRemove, quantity: 0}) })
        .then(function(r){ return r.json(); }).then(function(cart){ renderDrawer(cart, null); });
      return;
    }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });

  // ---- wire header bag link to open drawer --------------------------------
  document.addEventListener('DOMContentLoaded', function(){
    var bagLinks = document.querySelectorAll('a[href$="/cart"]');
    bagLinks.forEach(function(a){
      if(a.closest('.gd-header__utils')) a.setAttribute('data-gd-cart-open','');
    });
  });
})();
